"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Title = exports.StyledIcon = exports.Root = exports.classes = void 0;
const styles_1 = require("@mui/material/styles");
const Typography_1 = __importDefault(require("../typography/Typography"));
const Icon_1 = __importDefault(require("../icon/Icon"));
const PREFIX = "ResponseMessage";
exports.classes = {
    error: `${PREFIX}-error`
};
exports.Root = (0, styles_1.styled)("div")(({ theme }) => ({
    padding: "100px 0"
}));
exports.StyledIcon = (0, styles_1.styled)(Icon_1.default)(({ theme }) => ({
    width: "auto",
    height: "80px",
    color: theme.colours.inter,
    [`&.${exports.classes.error}`]: {
        color: theme.colours.error400
    }
}));
exports.Title = (0, styles_1.styled)(Typography_1.default)({ padding: "10px 0" });
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Jlc3BvbnNlLW1lc3NhZ2Uvc3R5bGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLGlEQUE4QztBQUM5QywwRUFBa0Q7QUFDbEQsd0RBQWdDO0FBRWhDLE1BQU0sTUFBTSxHQUFHLGlCQUFpQixDQUFDO0FBRXBCLFFBQUEsT0FBTyxHQUFHO0lBQ3JCLEtBQUssRUFBRSxHQUFHLE1BQU0sUUFBUTtDQUN6QixDQUFDO0FBRVcsUUFBQSxJQUFJLEdBQUcsSUFBQSxlQUFNLEVBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQyxFQUFFLEtBQUssRUFBRSxFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQ2hELE9BQU8sRUFBRSxTQUFTO0NBQ25CLENBQUMsQ0FBQyxDQUFDO0FBRVMsUUFBQSxVQUFVLEdBQUcsSUFBQSxlQUFNLEVBQUMsY0FBSSxDQUFDLENBQUMsQ0FBQyxFQUFFLEtBQUssRUFBRSxFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQ3JELEtBQUssRUFBRSxNQUFNO0lBQ2IsTUFBTSxFQUFFLE1BQU07SUFDZCxLQUFLLEVBQUUsS0FBSyxDQUFDLE9BQU8sQ0FBQyxLQUFLO0lBQzFCLENBQUMsS0FBSyxlQUFPLENBQUMsS0FBSyxFQUFFLENBQUMsRUFBRTtRQUN0QixLQUFLLEVBQUUsS0FBSyxDQUFDLE9BQU8sQ0FBQyxRQUFRO0tBQzlCO0NBQ0YsQ0FBQyxDQUFDLENBQUM7QUFFUyxRQUFBLEtBQUssR0FBRyxJQUFBLGVBQU0sRUFBQyxvQkFBVSxDQUFDLENBQUMsRUFBRSxPQUFPLEVBQUUsUUFBUSxFQUFFLENBQUMsQ0FBQyJ9